import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function LoginAdminSlug() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { loginAdmin } = useAuth();

  const [camara, setCamara] = useState(null);
  const [erro, setErro] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/publica/camara/${slug}`)
      .then(res => setCamara(res.data))
      .catch(() => setErro('Câmara não encontrada.'));
  }, [slug]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro('');
    try {
      await loginAdmin(email, senha);
      navigate('/');
    } catch (err) {
      setErro(err.response?.data?.error || 'E-mail ou senha inválidos.');
    } finally {
      setLoading(false);
    }
  };

  if (erro && !camara) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h2 style={{ color: '#e74c3c' }}>❌ {erro}</h2>
          <p>Verifique o link e tente novamente.</p>
        </div>
      </div>
    );
  }

  if (!camara) {
    return (
      <div style={styles.container}>
        <div style={styles.card}><p>Carregando...</p></div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {camara.logoUrl && (
          <img src={camara.logoUrl} alt="Logo" style={styles.logo} />
        )}
        <h1 style={styles.titulo}>{camara.nome}</h1>
        <p style={styles.subtitulo}>{camara.municipio} — {camara.estado}</p>
        <h2 style={styles.loginTitulo}>⚙️ Acesso Administrativo</h2>

        <form onSubmit={handleLogin} style={styles.form}>
          <input
            style={styles.input}
            type="email"
            placeholder="E-mail"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Senha"
            value={senha}
            onChange={e => setSenha(e.target.value)}
            required
          />
          {erro && <p style={styles.erro}>{erro}</p>}
          <button style={styles.botao} type="submit" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', display: 'flex',
    alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a3a5c, #2c3e50)',
  },
  card: {
    background: '#fff', borderRadius: 16, padding: 40,
    width: '100%', maxWidth: 400, textAlign: 'center',
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  },
  logo: { width: 90, height: 90, objectFit: 'contain', marginBottom: 12, borderRadius: 8 },
  titulo: { fontSize: 20, color: '#1a3a5c', margin: '0 0 4px' },
  subtitulo: { color: '#666', fontSize: 13, marginBottom: 24 },
  loginTitulo: { fontSize: 18, color: '#2c3e50', marginBottom: 20 },
  form: { display: 'flex', flexDirection: 'column', gap: 12 },
  input: {
    padding: '12px 16px', borderRadius: 8, fontSize: 15,
    border: '1px solid #ddd', outline: 'none',
  },
  botao: {
    padding: '13px', background: '#2c3e50', color: '#fff',
    border: 'none', borderRadius: 8, fontSize: 16,
    fontWeight: 'bold', cursor: 'pointer', marginTop: 4,
  },
  erro: { color: '#e74c3c', fontSize: 13, margin: 0 },
};